var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { SPACE_FILL } from "../View";
import { Text, TEXT_WEIGHT } from "../Text";
import { SPACING_M } from "../helpers";
import { FormGroupContextProvider } from "../FormGroupContext";
var Wrapper = styled(StackView)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", ";\n"], ["\n    padding: 0 ", ";\n"])), SPACING_M);
export var SideFilterItem = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, title = _a.title, contentRenderer = _a.contentRenderer;
    return (React.createElement(Wrapper, { spaceFill: SPACE_FILL.all, direction: STACK_DIRECTION.column, gap: STACK_GAP.s },
        React.createElement(Text, { weight: TEXT_WEIGHT.bold, truncate: true }, title),
        React.createElement(FormGroupContextProvider, { value: { disabled: disabled } }, contentRenderer({ disabled: disabled }))));
};
var templateObject_1;
//# sourceMappingURL=SideFilterItem.js.map